import api from '../api/axiosConfig';

export const vacancyRequestsApi = {
    getList: async (skip = 0, limit = 20, org_id, filters = {}) => {
        const params = { skip, limit, ...filters };

        if (org_id === 'all') {
            const response = await api.get('/vacancy_requests/list', {
                params,
                silent: true
            });
            // Возвращаем и items, и total_pages, и total_items из ответа бэкенда
            return {
                items: response.data.data.items,
                total_pages: response.data.data.total_pages,
                total_items: response.data.data.total_items
            };
        }
        const response = await api.get('/vacancy_requests/list', {
            params: { ...params, org_id },
            silent: true
        });
        // Возвращаем и items, и total_pages, и total_items из ответа бэкенда
        return {
            items: response.data.data.items,
            total_pages: response.data.data.total_pages,
            total_items: response.data.data.total_items
        };
    },

    getById: async (id, organisationId) => {
        // const response = await api.get(`/vacancy_requests/${id}?org_id=${organisationId}`, {
        //     silent: true
        // });
        const response = await api.get(`/vacancy_requests/${id}`, {
            silent: true
        });
        return response.data;
    },

    create: async (organisationId, vacancyRequest) => {
        const response = await api.post(`/vacancy_requests/create?org_id=${organisationId}`, vacancyRequest, {
            loadingMessage: 'Создание заявки на вакансию...',
            successMessage: 'Заявка на вакансию успешно создана'
        });
        return response.data;
    },

    update: async (id, organisationId, vacancyRequest) => {
        const response = await api.put(`/vacancy_requests/${id}?org_id=${organisationId}`, vacancyRequest, {
            loadingMessage: 'Обновление заявки на вакансию...',
            successMessage: 'Заявка на вакансию успешно обновлена'
        });
        return response.data;
    },

    delete: async (id, organisationId) => {
        const response = await api.delete(`/vacancy_requests/${id}`, {
            params: { org_id: organisationId },
            loadingMessage: 'Удаление заявки на вакансию...',
            successMessage: 'Заявка на вакансию успешно удалена'
        });
        return response.data;
    },

    approve: async (id, organisationId, variant) => {
        const response = await api.put(`/vacancy_requests/${id}/approve?org_id=${organisationId}`, variant, {
            loadingMessage: 'Утверждение заявки...',
            successMessage: 'Заявка успешно утверждена'
        });
        return response.data;
    },

    getHistory: async (id, organisationId) => {
        const response = await api.get(`/vacancy_requests/${id}/history?org_id=${organisationId}`, {
            silent: true
        });
        return response.data;
    },

    getMovementsByVacancyRequest: async (id) => {
        const response = await api.get(`/movements/get_by_vacancy_request/${id}`, {
            silent: true
        });
        return response.data.data;
    },

    updateMovementStatus: async (id, status) => {
        const response = await api.put(`/movements/${id}`, { status: status }, {
            loadingMessage: 'Изменение статуса движения...',
            successMessage: 'Статус движения успешно изменён'
        });
        return response.data;
    },

    getVacanciesByVacancyRequest: async (id) => {
        const response = await api.get(`/vacancy_requests/${id}/vacancies`, {
            silent: true
        });
        return response.data.data;
    },

};
